import { TEstimateBaseItem } from '../../types/estimate/estimate';
import { roundDown } from '../../utils/estimate';
import { Template, generate } from '@pdfme/generator';
import { generatePdfUint8Array } from '../../generatePdf/pdfUtilities';

export const createCustomEstimate1 = async (
  basePdfs: any,
  data: any,
  font: any,
  isParentAmountHidden: boolean
) => {
  return createPdf(basePdfs, data, font, isParentAmountHidden);
};

const summarySchemas = (data: any) => {
  const clientNameLength = data.client_name.length;
  let fontSize;

  if (clientNameLength <= 15) {
    fontSize = 15;
  } else if (clientNameLength <= 20) {
    fontSize = 11;
  } else if (clientNameLength <= 45) {
    fontSize = 9;
  }

  // CONOC標準と同様の文字数
  const companyNameLength = data.company_name.length;
  let companyNameFontSize;

  if (companyNameLength <= 7) {
    companyNameFontSize = 15;
  } else if (companyNameLength <= 12) {
    companyNameFontSize = 15 - (companyNameLength - 7);
  } else {
    companyNameFontSize = 9;
  }

  const schemas: any = {};
  schemas['client_name'] = {
    type: 'text',
    position: {
      x: 15,
      y: 28
    },
    width: 80,
    height: 6,
    alignment: 'center',
    fontSize: fontSize
  };
  schemas['billing_total'] = {
    type: 'text',
    position: {
      x: 40,
      y: 75
    },
    width: 45,
    height: 6,
    alignment: 'right',
    fontSize: 15
  };
  schemas['construct_sub'] = {
    type: 'text',
    position: {
      x: 28,
      y: 37.7
    },
    width: 73,
    height: 6,
    fontSize: 8
  };
  schemas['total_price'] = {
    type: 'text',
    position: {
      x: 28,
      y: 83.85
    },
    width: 19,
    height: 3,
    fontSize: 8
  };
  schemas['tax'] = {
    type: 'text',
    position: {
      x: 69,
      y: 83.85
    },
    width: 19,
    height: 3,
    fontSize: 8
  };
  schemas['site_address'] = {
    type: 'text',
    position: {
      x: 28,
      y: 47
    },
    width: 65,
    height: 6,
    fontSize: 9
  };
  schemas['code'] = {
    type: 'text',
    position: {
      x: 171,
      y: 15
    },
    width: 23,
    height: 3,
    alignment: 'left',
    fontSize: 8
  };
  schemas['estimate_date'] = {
    type: 'text',
    position: {
      x: 171,
      y: 19.5
    },
    width: 23,
    height: 3,
    alignment: 'left',
    fontSize: 8
  };
  schemas['company_name'] = {
    type: 'text',
    position: {
      x: 135,
      y: 40
    },
    width: 45,
    height: 6,
    alignment: 'left',
    fontSize: companyNameFontSize
  };
  schemas['zipcode'] = {
    type: 'text',
    position: {
      x: 135,
      y: 52
    },
    width: 55,
    height: 3.5,
    fontSize: 8
  };
  schemas['address'] = {
    type: 'text',
    position: {
      x: 135,
      y: 55.5
    },
    width: 60,
    height: 10,
    fontSize: 8
  };
  schemas['tel_no_label'] = {
    type: 'text',
    position: {
      x: 135,
      y: 65
    },
    width: 8,
    height: 3.5,
    fontSize: 8
  };
  schemas['tel_no'] = {
    type: 'text',
    position: {
      x: 148,
      y: 65
    },
    width: 20,
    height: 3.5,
    fontSize: 8
  };
  schemas['fax_no_label'] = {
    type: 'text',
    position: {
      x: 168,
      y: 65
    },
    width: 8,
    height: 3.5,
    fontSize: 8
  };
  schemas['fax_no'] = {
    type: 'text',
    position: {
      x: 176,
      y: 65
    },
    width: 20,
    height: 3.5,
    fontSize: 8
  };
  schemas['summary'] = {
    type: 'text',
    position: {
      x: 15,
      y: 265
    },
    width: 180,
    height: 18,
    fontSize: 7
  };

  [...Array(16)].forEach((_: any, i: number) => {
    schemas[`item_no${i}`] = {
      type: 'text',
      position: {
        x: 14.3,
        y: 108 + 9.45 * i
      },
      width: 4.5,
      height: 4,
      alignment: 'center',
      fontSize: 7
    };
    schemas[`item_name${i}`] = {
      type: 'text',
      position: {
        x: 20.2,
        y: 105.8 + 9.45 * i
      },
      width: 111,
      height: 3.5,
      fontSize: 8,
      fontName: data[`item_no${i}`] ? 'mincho' : 'minchoBold'
    };
    schemas[`item_spec${i}`] = {
      type: 'text',
      position: {
        x: 20.2,
        y: 110.6 + 9.45 * i
      },
      width: 111,
      height: 3.5,
      fontSize: 6
    };
    schemas[`item_quantity${i}`] = {
      type: 'text',
      position: {
        x: 133.6,
        y: 108 + 9.45 * i
      },
      width: 8.5,
      height: 4,
      alignment: 'center',
      fontSize: 8
    };
    schemas[`item_unit${i}`] = {
      type: 'text',
      position: {
        x: 144,
        y: 108 + 9.45 * i
      },
      width: 8.5,
      height: 4,
      alignment: 'center',
      fontSize: 8
    };
    schemas[`item_unit_price${i}`] = {
      type: 'text',
      position: {
        x: 154.6,
        y: 108 + 9.45 * i
      },
      width: 18.7,
      height: 4,
      alignment: 'right',
      fontSize: 8
    };
    schemas[`item_all_selling_price${i}`] = {
      type: 'text',
      position: {
        x: 175.8,
        y: 108 + 9.45 * i
      },
      width: 18.7,
      height: 4,
      alignment: 'right',
      fontSize: 8
    };
  });
  return schemas;
};

const detailSchemas = (data: any) => {
  const schemas: any = {};

  schemas['summary'] = {
    type: 'text',
    position: {
      x: 15,
      y: 263
    },
    width: 180,
    height: 18,
    fontSize: 7
  };

  [...Array(25)].forEach((_: any, i: number) => {
    schemas[`item_no${i}`] = {
      type: 'text',
      position: {
        x: 14.3,
        y: 21 + 9.43 * i
      },
      width: 4.5,
      height: 4,
      alignment: 'center',
      fontSize: 7
    };
    schemas[`item_name${i}`] = {
      type: 'text',
      position: {
        x: 20.2,
        y: 19 + 9.43 * i
      },
      width: 111,
      height: 3.5,
      fontSize: 8,
      fontName: data[`item_no${i}`] ? 'mincho' : 'minchoBold'
    };
    schemas[`item_spec${i}`] = {
      type: 'text',
      position: {
        x: 20.2,
        y: 23.8 + 9.43 * i
      },
      width: 111,
      height: 3.5,
      fontSize: 6
    };
    schemas[`item_quantity${i}`] = {
      type: 'text',
      position: {
        x: 133.6,
        y: 21 + 9.43 * i
      },
      width: 8.5,
      height: 4,
      alignment: 'center',
      fontSize: 8
    };
    schemas[`item_unit${i}`] = {
      type: 'text',
      position: {
        x: 144,
        y: 21 + 9.43 * i
      },
      width: 8.5,
      height: 4,
      alignment: 'center',
      fontSize: 8
    };
    schemas[`item_unit_price${i}`] = {
      type: 'text',
      position: {
        x: 154.6,
        y: 21 + 9.43 * i
      },
      width: 18.7,
      height: 4,
      alignment: 'right',
      fontSize: 8
    };
    schemas[`item_all_selling_price${i}`] = {
      type: 'text',
      position: {
        x: 175.8,
        y: 21 + 9.43 * i
      },
      width: 18.7,
      height: 4,
      alignment: 'right',
      fontSize: 8
    };
  });
  return schemas;
};

export const createPdf = async (
  basePdfs: any,
  data: any,
  font: any,
  isParentAmountHidden: boolean
) => {
  const pdfs: any = [];
  let itemInputs: any = {};

  // 階層別に振り分け
  const mainItems = data.items.filter((item: TEstimateBaseItem) => {
    return item.layer === 1;
  });
  const allSecondItems = data.items.filter((item: TEstimateBaseItem) => {
    return item.layer === 2;
  });

  const itemCount = mainItems.length;
  let secondItemCount = 0;
  mainItems.forEach((item: any) => {
    if (item.has_under_layer_flg) {
      //　大項目が明細ありの場合、idが位置する小項目を取得
      const secondItems = allSecondItems.filter(
        (allSecondItem: TEstimateBaseItem) => {
          return allSecondItem.parent_item_id === item.id;
        }
      );
      secondItemCount += secondItems.length;
    }
  });
  const maxCount = itemCount + secondItemCount;

  // サマリ情報の設定
  itemInputs['client_name'] = `${data.client_name} ${data.honorific_title}`;
  itemInputs['billing_total'] = `¥${Number(data.billing_total).toLocaleString(
    'ja-JP'
  )}`;
  itemInputs['construct_sub'] = window.location.pathname.includes('/received')
    ? data.construct_name
    : data.construct_sub;
  itemInputs['total_price'] = `¥${data.total_price.toLocaleString('ja-JP')}`;
  itemInputs['tax'] = `¥${data.tax.toLocaleString('ja-JP')}`;
  itemInputs['site_address'] = data.site_address;
  itemInputs['code'] = data.code;
  itemInputs['estimate_date'] = window.location.pathname.includes('/received')
    ? data.submission_date
    : data.submission_date_str;
  itemInputs['company_name'] = data.company_name;
  itemInputs['zipcode'] = `〒${data.company_postal_code.slice(
    0,
    3
  )} - ${data.company_postal_code.slice(-4)}`;
  itemInputs['address'] = data.company_address;
  itemInputs['tel_no_label'] = 'TEL:';
  itemInputs['tel_no'] = data.company_phone_number;
  itemInputs['fax_no_label'] = 'FAX:';
  itemInputs['fax_no'] = data.company_fax_number;

  let dataCount = 0;
  let pageCount = 0;
  let lineCount = 0;

  // 大項目
  for (var i = 0; i < mainItems.length; i++) {
    // console.log(`大: ${dataCount}, ${pageCount}, ${lineCount}, ${maxCount}`);
    const item = mainItems[i];
    itemInputs[`item_name${lineCount}`] = item.name;
    itemInputs[`item_spec${lineCount}`] =
      item.spec.length > 50 ? item.spec.substr(0, 50) + '...' : item.spec;
    itemInputs[`item_quantity${lineCount}`] = String(item.quantity);
    itemInputs[`item_unit${lineCount}`] = item.unit_name;
    // ユタカさんの場合、明細を持つ大項目の単価は非表示にする
    itemInputs[`item_unit_price${lineCount}`] =
      item.has_under_layer_flg && isParentAmountHidden
        ? ''
        : `¥${Number(item.selling_unit_price).toLocaleString('ja-JP')}`;
    const itemAllSellingPrise = roundDown(
      item.selling_unit_price * item.quantity,
      0
    );
    // ユタカさんの場合、明細を持つ大項目の金額は非表示にする
    itemInputs[`item_all_selling_price${lineCount}`] =
      item.has_under_layer_flg && isParentAmountHidden
        ? ''
        : `¥${itemAllSellingPrise.toLocaleString('ja-JP')}`;

    lineCount += 1;
    dataCount += 1;

    // 改ページ判定
    if (
      (pageCount === 0 && lineCount === 16) ||
      (pageCount > 0 && lineCount === 25)
    ) {
      let template: Template = { basePdf: '', schemas: [] };
      // 最終ページの判定
      if (dataCount === maxCount) {
        itemInputs['summary'] = data.summary;
        template = {
          basePdf: pageCount === 0 ? basePdfs[0] : basePdfs[2],
          schemas:
            pageCount === 0
              ? [summarySchemas(itemInputs)]
              : [detailSchemas(itemInputs)]
        };
      } else {
        template = {
          basePdf: pageCount === 0 ? basePdfs[1] : basePdfs[3],
          schemas:
            pageCount === 0
              ? [summarySchemas(itemInputs)]
              : [detailSchemas(itemInputs)]
        };
      }
      const inputs = [{ ...itemInputs }];
      const pdf = await generatePdfUint8Array(template, inputs, font);
      pdfs.push(pdf);
      // データ情報初期化
      lineCount = 0;
      itemInputs = {};
      pageCount += 1;
    }

    if (item.has_under_layer_flg) {
      //　大項目が明細ありの場合、idが位置する小項目を取得
      const secondItems = allSecondItems.filter(
        (allSecondItem: TEstimateBaseItem) => {
          return allSecondItem.parent_item_id === item.id;
        }
      );

      if (secondItems.length > 0) {
        // 小項目
        for (var j = 0; j < secondItems.length; j++) {
          // console.log(`小: ${dataCount}, ${pageCount}, ${lineCount}, ${maxCount}`);
          const secondItem = secondItems[j];
          itemInputs[`item_no${lineCount}`] = String(j + 1);
          itemInputs[`item_name${lineCount}`] = secondItem.name;
          itemInputs[`item_spec${lineCount}`] =
            secondItem.spec.length > 40
              ? secondItem.spec.substr(0, 40) + '...'
              : secondItem.spec;
          itemInputs[`item_quantity${lineCount}`] = String(secondItem.quantity);
          itemInputs[`item_unit${lineCount}`] = secondItem.unit_name;
          itemInputs[`item_unit_price${lineCount}`] = `¥${Number(
            secondItem.selling_unit_price
          ).toLocaleString('ja-JP')}`;
          const itemAllSellingPrise = roundDown(
            secondItem.selling_unit_price * secondItem.quantity,
            0
          );
          itemInputs[
            `item_all_selling_price${lineCount}`
          ] = `¥${itemAllSellingPrise.toLocaleString('ja-JP')}`;

          lineCount += 1;
          dataCount += 1;

          // 改ページ判定
          if (
            (pageCount === 0 && lineCount === 16) ||
            (pageCount > 0 && lineCount === 25)
          ) {
            let template: any = {};
            // 最終ページの判定
            if (dataCount === maxCount) {
              itemInputs['summary'] = data.summary;
              template = {
                fontName: 'mincho',
                basePdf: pageCount === 0 ? basePdfs[0] : basePdfs[2],
                schemas:
                  pageCount === 0
                    ? [summarySchemas(itemInputs)]
                    : [detailSchemas(itemInputs)]
              };
            } else {
              template = {
                fontName: 'mincho',
                basePdf: pageCount === 0 ? basePdfs[1] : basePdfs[3],
                schemas:
                  pageCount === 0
                    ? [summarySchemas(itemInputs)]
                    : [detailSchemas(itemInputs)]
              };
            }
            const inputs = [{ ...itemInputs }];
            const pdf = await generatePdfUint8Array(template, inputs, font);
            pdfs.push(pdf);
            // データ情報初期化
            lineCount = 0;
            itemInputs = {};
            pageCount += 1;
          }
        }
      }
    }
  }
  // 残りの仕様情報があれば出力
  if (Object.keys(itemInputs).length > 0) {
    // console.log("last page");
    itemInputs['summary'] = data.summary;
    let template: any = {
      fontName: 'mincho',
      basePdf: pageCount === 0 ? basePdfs[0] : basePdfs[2],
      schemas:
        pageCount === 0
          ? [summarySchemas(itemInputs)]
          : [detailSchemas(itemInputs)]
    };
    const inputs = [{ ...itemInputs }];
    const pdf = await generatePdfUint8Array(template, inputs, font);
    pdfs.push(pdf);
  }

  return pdfs;
};
